import styles from "./home.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};


const customerSlider = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
}

const Home = () => {
  const navigate = useNavigate();

  return (<>
    <div className={`${styles.mainDiv}`}>
      <div className={`${styles.BannerSec} ${styles.HomeBannerSec}`}>
        <Carousel
          className={`${styles.BannerSlide}`}
          swipeable={true}
          arrows={false}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition="2000ms all"
          transitionDuration={400}
        >
          <div className={`${styles.item}`}>
            <div className={`${styles.Banner}`}>
              <img src="/images/home_banner.jpg" className={`${styles.BannerBG}`} alt="" />
              <div className={`${styles.Container}`}>
                <div className={`${styles.BannerContent}`}>
                  <div className={`${styles.BannerText}`}>
                    <p className={`${styles.BannerTitle} ${styles.Heading}`}>Seamless Logistics</p>
                    <p className={`${styles.BannerManagementText}`}>From Pick-Up to Delivery<span></span></p>
                    <p className={`${styles.BannerTextDescription}`}>"Optimising your pickup and delivery with cutting-edge technology for efficient tracking, scheduling, and delivery management."</p>
                    <button className={`${styles.HomeBU}`} onClick={(e) => navigate("/sign-up")}>Try Our Solution for Free</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </div>

      <div className={`${styles.FeatresSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.FeaturesSecHeading} ${styles.BodySecHeading}`}>Features That Help Your Deliveriveries</h3>
          <p className={`${styles.FeaturesSecSubHeading} ${styles.BodySecSubHeading}`}>Projects on Time<span></span></p>
        </div>
        <div className={`${styles.FeatresSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image1.jpg" alt="" />
            </div>
            <h2 className={`${styles.FeatresSecContainerItemHeading}`} style={{ lineHeight: '25px', fontSize: '20px' }}>Real-time tracking</h2>
            <p className={`${styles.FeatresSecContainerItemDesc}`}>Custom dashboards that provide real-time
              insights into project progress and team
              performance.<span>Reed More</span></p>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image2.jpg" alt="" />
            </div>
            <h2 className={`${styles.FeatresSecContainerItemHeading}`} style={{ lineHeight: '25px', fontSize: '20px' }}>Automated scheduling</h2>
            <p className={`${styles.FeatresSecContainerItemDesc}`}>Chat, comment, and share files directly
              within tasks to keep your team
              connected.<span>Reed More</span></p>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image3.jpg" alt="" />
            </div>
            <h2 className={`${styles.FeatresSecContainerItemHeading}`} style={{ lineHeight: '25px', fontSize: '20px' }}>End-to-end supply chain visibility</h2>
            <p className={`${styles.FeatresSecContainerItemDesc}`}>Track time spent on tasks and projects
              to ensure deadlines and budgets
              are met.<span>Reed More</span></p>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image4.jpg" alt="" />
            </div>
            <h2 className={`${styles.FeatresSecContainerItemHeading}`} style={{ lineHeight: '25px', fontSize: '20px' }}>Seamless integration with your operations</h2>
            <p className={`${styles.FeatresSecContainerItemDesc}`}>Generate detailed reports to measure
              performance and optimise
              workflows.<span>Reed More</span></p>
          </div>
        </div>
      </div>
      <div className={`${styles.TaskFlowSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.TaskFlowSecHeading} ${styles.BodySecHeading}`}>Start using our solution</h3>
          <p className={`${styles.TaskFlowSecSubHeading} ${styles.BodySecSubHeading}`}>3 Simple Steps<span></span></p>
        </div>
        <div className={`${styles.TaskFlowSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <img src="/images/signupTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Register your business</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Create an account in just a few minutes and start your free trial.</p>
          </div>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <img src="/images/setupTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Schedule your customers pickup</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Stay on top of your projects with realtime tracking and integrated team collaboration.</p>
          </div>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <img src="/images/trackTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Get your pickup and Delivery APP</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Stay on top of your projects with
              realtime tracking and integrated team
              collaboration."</p>
          </div>
        </div>
      </div>
      <div className={`${styles.CustomerSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.CustomerSecHeading} ${styles.BodySecHeading}`}>What Our Customers Are </h3>
          <p className={`${styles.CustomerSecSubHeading} ${styles.BodySecSubHeading}`}>Saying<span></span></p>
        </div>
        <div className={`${styles.Container}`}>
          <Carousel
            responsive={customerSlider}
            className={`${styles.customerSlider}`}
            swipeable={true}
            arrows={false}
            draggable={true}
            showDots={false}
            ssr={true}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2500000}
            keyBoardControl={true}
            customTransition="2000ms all"
            transitionDuration={300}
          >
            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>TaskFlow has completely streamlined our workflow. It’s easy to use,
                  and our team’s productivity has increased dramatically.</p>
                <p className={`${styles.CustomerDesignation}`}>“Marketing Manager”</p>
                <p className={`${styles.CustomerName}`}> Lucy H </p>
              </div>
            </div>
            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>Great tool for remote teams. We stay in sync and never miss a deadline.</p>
                <p className={`${styles.CustomerDesignation}`}>“Operations Director”</p>
                <p className={`${styles.CustomerName}`}> Chris M </p>
              </div>
            </div>

            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>The task management features are fantastic. We can now see exactly where
                  each project stands at any moment.</p>
                <p className={`${styles.CustomerDesignation}`}>“Product Owner”</p>
                <p className={`${styles.CustomerName}`}> James B </p>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
      <div className={`${styles.PlanSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.PlanSecHeading} ${styles.BodySecHeading}`}>Affordable Plans for Every</h3>
          <p className={`${styles.PlanSecSubHeading} ${styles.BodySecSubHeading}`}>Team<span></span></p>
        </div>
        <div className={`${styles.PlanSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/freePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Free Plan</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>"Individual users, very small businesses, or those testing the platform." Features: 5 bookings per month</p>
            <p className={`${styles.planPriceText}`}>Price: <span>Free</span></p>
          </div>
          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/proPlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Standard Plan</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>"Growing businesses with moderate shipping volumes." Features: 100 bookings per month</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£350/month</span></p>
          </div>
          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/enterprisePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Premium Plan</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>"Businesses with high shipping volumes and complex logistics needs." Features:  200 bookings per month with driver's pickup app</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£760/month</span></p>
          </div>
          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/enterprisePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Full Plan</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>"Large corporations with highly specialized logistics requirements." Features: 500 bookings per month with Driver's pickup app, Delivery app</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£2500/month</span></p>
          </div>
          {/*<button className={`${styles.eachPlanButton} `}>Each Plan</button>*/}
        </div>
      </div>

      <div className={`${styles.ExpertSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          {/*<h3 className={`${styles.ExpertSecHeading} ${styles.BodySecHeading}`}>Built by Experts, Designed for</h3>
          <p className={`${styles.ExpertSecSubHeading} ${styles.BodySecSubHeading}`}>Team<span></span></p>*/}
        </div>
        {/*<div className={`${styles.ExpertSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.ExpertSecContentImage}`}>
            <img src="/images/expertImage1.jpg" alt="" />
          </div>
          <div className={`${styles.ExpertSecContent}`}>
            <h3>Content:</h3>
            <p>"TaskFlow was created by a team of experienced project managers and
              software engineers who understand the challenges of managing
              complex projects. We are passionate about helping teams achieve
              success with less effort and more impact."</p>
          </div>
        </div>*/}
      </div>


    </div>
  </>);
};

export default Home;